var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{attrs:{"label":"Label","value":"This is an invalid text","invalidText":"Invalid input","invalid":true,"showInvalidText":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }